// moms-harness:anchor v2
// Spec: docs/spec/settlement/SPEC-settlement-mwp-mlt-sku-attribute-registration-B.yaml
// JIRA: LOGISPRD-13286
// MA18 엑셀 업로드 — **서버 업로드 API 는 없다.** xlsx 를 클라에서 파싱해 신규 행으로 반영하고,
// 사용자가 검토·선택한 뒤 [저장]이 등록(POST /bulk) 경로를 탄다. MA02 와 같은 흐름이다.
//
// ⚠️ **화주코드 열은 읽지 않는다.** 등록은 화주 단위 요청이고 대상 화주는 필터에서 고른 값이다.
// 파일에 화주코드가 있어도 무시한다 — 파일과 필터가 어긋날 때 조용히 남의 화주로 채번되면
// 되돌릴 수 없다.
import ExcelJS from 'exceljs'
import { NUMERIC_COLUMNS, UPLOAD_HEADER_MAP } from './consts'
import { toPriceOrNull } from './toPriceOrNull'

export interface ImportedRow {
  [key: string]: string | number | null
}

/** 셀 값 → 문자열. ExcelJS 는 리치텍스트·수식을 객체로 준다. */
const cellText = (raw: ExcelJS.CellValue): string => {
  if (raw == null) return ''
  if (typeof raw === 'object') {
    if ('text' in raw) return String((raw as { text: unknown }).text)
    if ('result' in raw) return String((raw as { result: unknown }).result ?? '')
    if ('richText' in raw) return (raw as { richText: { text: string }[] }).richText.map((t) => t.text).join('')
  }
  return String(raw)
}

export const parseSkuAttributeExcel = async (file: File): Promise<ImportedRow[]> => {
  const wb = new ExcelJS.Workbook()
  await wb.xlsx.load(await file.arrayBuffer())
  const ws = wb.worksheets[0]
  if (!ws) return []

  // 1행 = 한글 헤더. 서버 다운로드 양식(`SkuAttributeExcelDto`)의 헤더와 같아야 한다
  const headerKeys: (string | null)[] = []
  ws.getRow(1).eachCell({ includeEmpty: true }, (cell, col) => {
    headerKeys[col] = UPLOAD_HEADER_MAP[cellText(cell.value).trim()] ?? null
  })
  if (!headerKeys.some(Boolean)) {
    throw new Error('헤더를 인식할 수 없습니다. 엑셀 다운로드 양식과 동일한 1행 헤더가 필요합니다.')
  }
  // 바코드 열이 없으면 등록이 불가능하다 — 채번 키라 다른 열로 대신할 수 없다
  if (!headerKeys.includes('barcode')) {
    throw new Error('「바코드」 열이 없습니다. 바코드는 SKU 채번 키라 반드시 필요합니다.')
  }

  const rows: ImportedRow[] = []
  ws.eachRow((row, rowNumber) => {
    if (rowNumber === 1) return
    const item: ImportedRow = {}
    let hasValue = false
    row.eachCell({ includeEmpty: true }, (cell, col) => {
      const key = headerKeys[col]
      if (!key) return
      const text = cellText(cell.value).trim()
      if (!text) return
      hasValue = true
      // 셀 편집과 **같은 변환**을 쓴다 — 두 입력 경로의 기준이 갈리면 한쪽만 저장에서 막힌다
      item[key] = NUMERIC_COLUMNS.has(key) ? toPriceOrNull(text) : text
    })
    if (hasValue) rows.push(item)
  })
  return rows
}
